import { Component, Input, OnInit } from '@angular/core';
import { Msisdn } from '../../msisdns';
import { getFlagClass } from '../../../utils/flag-class';

@Component({
  selector: 'cc-item-msisdn',
  templateUrl: './item-msisdn.component.html',
  styleUrls: ['./item-msisdn.component.scss']
})
export class ItemMsisdnComponent implements OnInit {
  @Input() msisdn: Msisdn;
  public getFlagClass = getFlagClass;

  constructor() {}

  ngOnInit() {}
}
